import { render, staticRenderFns } from "./TurtasNtrSearch.vue?vue&type=template&id=624e1bea&scoped=true&"
import script from "./TurtasNtrSearch.vue?vue&type=script&lang=js&"
export * from "./TurtasNtrSearch.vue?vue&type=script&lang=js&"
import style0 from "./TurtasNtrSearch.vue?vue&type=style&index=0&id=624e1bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e1bea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VCol,VContainer,VDataTable,VFooter,VRow,VSpacer,VTextField,VToolbar})
